import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import cookie from 'react-cookies';
import { Select } from 'react-input-textboxs';
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Button,
  TextField,
} from '@material-ui/core/';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import MuiAudioPlayer from './../../../Components/AudioPlayer';
import {
  fetchQaAudio,
  setPageName,
  QAAudioDecision,
  fetchRejectReajonList,
} from './../../../service/action/audio-track-action';
import { Loader } from './../../../Components';

class ApproveTranscript extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      folderName: '2-11-19',
      filterValues: {
        startDate: '',
        endDate: '',
      },
      pageNumber: 1,
      records: {},
      recordsError: {},
      transcriptText: '',
      model: false,
      reason: '',
      selectedId: '',
    };
    this.rederAudioFiles = this.rederAudioFiles.bind(this);
    this.renderRejectReasonModel = this.renderRejectReasonModel.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    const {
      QAManagement: { success },
    } = this.props;
    if (
      nextProps.QAManagement.success.message !== '' &&
      success.message !== nextProps.QAManagement.success.message
    ) {
      const {
        userLogin: { loggedUser },
      } = this.props;
      this.props.fetchQaAudio(
        loggedUser.username || cookie.load('username'),
        loggedUser.userType
      );
      this.props.fetchRejectReajonList();
    }
    if (
      nextProps.QAManagement.QACheck.data.length === 1 &&
      this.props.QAManagement.QACheck.data.length === 0
    ) {
      this.setState({
        transcriptText: nextProps.QAManagement.QACheck.data[0].transcript,
      });
    }

    //  console.log(nextProps)
    //  console.log(this.props)
    /*/const { records, recordsError } = this.state
        if (this.props.audioList.data !== nextProps.audioList.data) {
            nextProps.audioList.data.map((item, i) => {
                records[item.id] = item.transcript
                recordsError[item.id] = false
            })
            this.setState({ records, recordsError })
        }
        if (this.props.success.message !== nextProps.success.message) {
            const { filterValues: { startDate, endDate },pageNumber } = this.state
            let start_date = ''
            let end_date = ''
            if (startDate !== '' && endDate !== '') {
                let sdate = new Date(startDate)
                let edate = new Date(endDate)
                start_date = `${sdate.getFullYear()}-${sdate.getMonth() + 1}-${sdate.getDate()} 00:00:00`
                end_date = `${edate.getFullYear()}-${edate.getMonth() + 1}-${edate.getDate()} 23:59:59`
            }
            this.props.fetchAudioTracks(cookie.load('username'), start_date, end_date, pageNumber, pageNumber * 10)
        }*/
  }

  componentWillMount() {
    this.props.setPageName('Audio QA');
    const {
      userLogin: { loggedUser },
    } = this.props;
    this.props.fetchQaAudio(
      loggedUser.username || cookie.load('username'),
      loggedUser.userType
    );
    this.props.fetchRejectReajonList();
  }

  handleOnChange(e, key) {
    var reg = /^[a-zA-Z\s*]*$/i;
    const { records, recordsError } = this.state;
    if (reg.test(e.target.value)) {
      records[key] = e.target.value.replace(/(\r\n|\n|\r)/gm, '');
      recordsError[key] = false;
      this.setState({ records, recordsError });
    } else {
      records[key] = e.target.value.replace(/(\r\n|\n|\r)/gm, '');
      recordsError[key] = true;
      this.setState({ records, recordsError });
    }
  }

  handleModelFormValueChange(value, key) {
    this.setState({ [key]: value });
  }

  handleModel(value) {
    this.setState({ model: value });
    document.getElementById('overlay').classList.toggle('overlay');
  }

  handleQAAudioDecision(e) {
    e.preventDefault();
    const {
      userLogin: { loggedUser },
      QAManagement: { rejectReasons },
    } = this.props;
    const { selectedId, transcriptText, reason } = this.state;
    const det = rejectReasons.find((data) => reason === data.error);
    this.handleModel(false);
    this.props.QAAudioDecision(
      cookie.load('username'),
      selectedId,
      '2',
      transcriptText,
      det.error_id,
      loggedUser.userType
    );
  }
  renderRejectReasonModel() {
    const { reason } = this.state;
    const {
      QAManagement: { rejectReasons },
    } = this.props;
    const opt = rejectReasons.map((data) => data.error);

    return (
      <div className='update-model'>
        <h2 style={{ marginBottom: 20 }}>Reason for Rejection?</h2>
        <form>
          <Select
            value={reason}
            onChange={(value) =>
              this.handleModelFormValueChange(value, 'reason')
            }
            filter
            label='Select Reason'
            options={opt}
          />
          {reason !== '' ? (
            <div className='btn-wrapper'>
              <button
                onClick={(e) => this.handleQAAudioDecision(e)}
                type='submit'
                className='btn submit-btn'
              >
                Submit
              </button>
              <button
                onClick={() => this.handleModel(false)}
                type='submit'
                className='btn clear-btn'
              >
                Cancel
              </button>
            </div>
          ) : (
            <div className='btn-wrapper'>
              <button
                onClick={(e) => e.preventDefault()}
                type='submit'
                className='btn submit-btn'
              >
                Submit
              </button>
              <button
                onClick={() => this.handleModel(false)}
                type='submit'
                className='btn clear-btn'
              >
                Cancel
              </button>
            </div>
          )}
        </form>
      </div>
    );
  }
  rederAudioFiles(list) {
    const {
      userLogin: { loggedUser },
    } = this.props;
    const { recordsError, transcriptText } = this.state;
    return list.map((item, i) => {
      return (
        <ExpansionPanel
          expanded
          key={item.file_path + i}
          className={(i + 1) % 2 === 0 ? 'even' : 'add'}
        >
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='panel1a-content'
            id='panel1a-header'
          >
            <div className='flexhvc'>
              <PlayCircleFilledIcon />
              <p style={{ paddingLeft: 10 }}>
                {item.file_path.replace(`http://10.101.1.134/rec/`, ``)}
              </p>
            </div>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div className='audio-result'>
              <MuiAudioPlayer src={item.file_path} autoPlay={true} />
              {/* <p style={{paddingBottom:10}}>Letters,space and asterisk(*) only allowed!!!</p> */}

              <TextField
                error={recordsError[item.id]}
                id='outlined-multiline-static'
                label={` ${
                  recordsError[item.id]
                    ? `Letters,space and asterisk(*) only allowed!!!`
                    : 'Enter the Transcript '
                }`}
                multiline
                rows='4'
                //value={records[item.id]}
                value={transcriptText}
                //readOnly
                onChange={(e) =>
                  this.setState({ transcriptText: e.target.value })
                }
                //onChange={(e) => this.handleOnChange(e, item.id)}
                onKeyDown={(e) => this.handleOnChange(e, item.id)}
                variant='outlined'
              />
              {/* props.saveAudioTracks({ item, transcript: transcript[i] }) */}
              <div className='btn-wrapper'>
                <Button
                  style={{ backgroundColor: '#bf1a1a' }}
                  disabled={recordsError[item.id]}
                  //onClick={() => this.props.QAAudioDecision(cookie.load('username'), item.id, '2', transcriptText, loggedUser.userType)}
                  onClick={() => [
                    this.handleModel(true),
                    this.setState({ selectedId: item.id }),
                  ]}
                  variant='contained'
                  color='primary'
                >
                  Rejected
                </Button>
                <Button
                  style={{ marginLeft: 10, backgroundColor: '#376704' }}
                  disabled={recordsError[item.id]}
                  onClick={() =>
                    this.props.QAAudioDecision(
                      cookie.load('username'),
                      item.id,
                      '1',
                      transcriptText,
                      0,
                      loggedUser.userType
                    )
                  }
                  variant='contained'
                  color='primary'
                >
                  Approved
                </Button>
              </div>
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      );
    });
  }
  triggerFetchAudio(pageNumber) {
    const {
      filterValues: { startDate, endDate },
    } = this.state;
    let start_date = '';
    let end_date = '';
    if (startDate !== '' && endDate !== '') {
      let sdate = new Date(startDate);
      let edate = new Date(endDate);
      start_date = `${sdate.getFullYear()}-${
        sdate.getMonth() + 1
      }-${sdate.getDate()} 00:00:00`;
      end_date = `${edate.getFullYear()}-${
        edate.getMonth() + 1
      }-${edate.getDate()} 23:59:59`;
    }

    this.props.fetchAudioTracks(
      cookie.load('username'),
      start_date,
      end_date,
      pageNumber,
      pageNumber * 10
    );
    this.setState({ pageNumber });
  }

  render() {
    const {
      QAManagement: { QACheck, loading },
    } = this.props;
    return (
      <div className='audio-to-trans-page'>
        {this.state.model ? this.renderRejectReasonModel() : null}
        {loading ? (
          <Loader />
        ) : (
          <div className='audio-result-contnet'>
            {QACheck.data.length >= 1 ? (
              this.rederAudioFiles(QACheck.data)
            ) : (
              <p style={{ textAlign: 'center', padding: 20 }}>
                No data Found!!.
              </p>
            )}
            {/* <p style={{ textAlign: "center", padding: 20 }}>Enter the File name to dispaly the Audio files.</p> */}
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { userLogin, QAManagement } = state;
  //const { QAManagement, loading, success, error } = state.AudioToTrackReducer

  return {
    QAManagement,
    //loading,
    userLogin,
    //success,
    //error
  };
}

export default withRouter(
  connect(mapStateToProps, {
    fetchQaAudio,
    setPageName,
    QAAudioDecision,
    fetchRejectReajonList,
  })(ApproveTranscript)
);
